// import _ from 'lodash';
import React, { useState } from 'react';
import { FormGroup, ControlLabel, Alert, Modal, Button, DatePicker } from 'rsuite';
import { dateFns } from '../DateFnsUtils';
import { cuotitasStoreService } from '../../services';
import roles from '../../constants/roles/roles';
import { Box } from '@material-ui/core';
import FormikWrapper from '../FormikWrapper';
import InputElement from '../MUIInputElement';
import RadioButtonGroup from '../MUIGenderRadioGroup';
import createUserData from '../../helpers/createNewSellerData';
import Password from '../../constants/logins/password';
import USERS from '../../constants/logins/users';
import * as yup from 'yup';
// eslint-disable-next-line no-unused-vars
import { mockResponse } from '../../utils/utils';

const sellerRegistrationModel = {
    name: {
        name: 'name',
        label: 'Nombre',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un nombre válido',
    },
    lastName: {
        name: 'lastName',
        label: 'Apellido',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un apellido válido',
    },
    gender: {
        name: 'gender',
        label: 'Género',
        required: false,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: '',
    },
    dni: {
        name: 'dni',
        label: 'DNI',
        required: false,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un documento válido',
    },
    businessId: {
        name: 'businessId',
        label: 'Id del Comercio',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un id válido',
    },
    role: {
        name: 'role',
        label: 'Rol',
        required: true,
        requiredErrorMessage: 'Campo requerido',
    },
    user: {
        name: 'user',
        label: 'Usuario',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'El nombre de usuario no puede tener espacios',
    },
    password: {
        name: 'password',
        label: 'Contraseña',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa una contraseña válida',
    },
};

const {
    name,
    lastName,
    dni,
    gender,
    businessId,
    role,
    user,
    password,
} = sellerRegistrationModel;

const sellerRegistrationInitialState = {
    [name.name]: '',
    [lastName.name]: '',
    [dni.name]: '',
    [gender.name]: '',
    [businessId.name]: '',
    [role.name]: '',
    [user.name]: '',
    [password.name]: '',
};

const noSpacesRegexp = /^\S*$/; ;
const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/;

const sellerRegistrationValidationSchema = yup.object().shape({
    [name.name]: yup.string()
        .max(60, 'El nombre ingresado es demasiado largo')
        .required(name.requiredErrorMessage),
    [lastName.name]: yup.string()
        .max(60, 'El apellido ingresado es demasiado largo')
        .required(lastName.requiredErrorMessage),
    // [dni.name]: yup.number()
    //     .test(
    //         'len',
    //         dni.invalidErrorMessage,
    //         val =>
    //             !val ||
    //             (val && (val.toString().length === 7 || val.toString().length === 8 || val.toString().length === 9)),
    //     )
    //     .positive(dni.invalidErrorMessage)
    //     .integer(dni.invalidErrorMessage)
    //     .typeError(dni.invalidErrorMessage)
    //     .required(dni.requiredErrorMessage),
    // [gender.name]: yup.string().required(gender.requiredErrorMessage),
    [businessId.name]: yup.string().required(businessId.requiredErrorMessage),
    [role.name]: yup.string().required(role.requiredErrorMessage),
    [password.name]: yup.string()
        .required('Campo requerido.')
        .min(8, 'Minimo 8 caracteres.')
        .max(20, 'Maximo 20 caracteres.')
        .matches(passwordRegex, 'La contraseña debe tener mínimo 8 caracteres con una letra mayúscula y un caracter especial.'),
    [user.name]: yup.string()
        .max(60, 'El nombre ingresado es demasiado largo')
        .required(user.requiredErrorMessage)
        .matches(noSpacesRegexp, user.invalidErrorMessage),
});

const genderValues = [{ value: 'M', label: 'M' }, { value: 'F', label: 'F' }];
const rolesValues = [{ value: roles['seller.digital-origination'], label: 'Vendedor' }, { value: roles['admin.digital-origination'], label: 'Administrador' }];

//
// Create seller user
//
export default function CreateSellerDialog ({ show, onHide }) {
    const [bornDate, setBornDate] = useState('');
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    const [showError, setShowError] = useState({ dni: false, user: false });

    //
    // Funcions

    const createSeller = (values) => {
        setIsLoading(true);
        // Build register data
        const data = createUserData(values, bornDate);
        // Delete documents if is empty
        if (!values.dni) { delete data.person.documents; };
        const attributes = [];
        for (const attribute of data.person.attributes) {
            if (attribute.value) { attributes.push(attribute); };
        }

        data.person.attributes = attributes;

        // return mockResponse()
        return cuotitasStoreService.register(data)
            .then(res => {
                Alert.success('El usuario se creo correctamente.', 5000);
                onHide();
            })
            .catch(error => {
                console.error(error);
                const dataError = error?.response?.data;
                const message = dataError.error;
                if (message === 'This username already exist.') {
                    Alert.error('Este nombre de usuario ya existe', 6000);
                    // Show error into form
                    setShowError({ user: true });
                    return setTimeout(() => {
                        setShowError({ user: false });
                    }, 7000);
                }

                if (message.includes('Not found store')) {
                    return Alert.error('No existe el id del comercio elegido', 6000);
                }

                // Password invalid
                if (dataError?.extra?.key === Password.invalid) {
                    if (dataError?.extra?.invalidations?.length) {
                        if (dataError?.extra?.invalidations?.some(i => i === 'personal_data')) {
                            return Alert.error('La contraseña no debe contener datos como nombre, apellido, fecha de nacimiento o DNI', 8000);
                        }
                        // "invalidations": [ "personal_data", "spaces", "symbols", "digits", ...],
                        const reason = dataError.extra.invalidations.join(',');
                        return Alert.error(`La contraseña es invalida. Razón: ${reason}`, 10000);
                    }
                    return Alert.error('La contraseña es invalida.', 5000);
                }

                if (dataError?.extra?.key === USERS.alreadyExist) {
                    return Alert.error('El DNI ingresado ya existe para otro usuario.', 5000);
                }

                return Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 6000);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    // eslint-disable-next-line no-unused-vars
    function getAge (date) {
        const today = new Date();
        const birthDate = new Date(date);
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        };
        return age;
    }

    const handleSubmit = values => {
        // TODO It is not necesario validate born date actually
        createSeller(values);
        // if (validateBornDate()) {
        // }
    };

    // const validateBornDate = () => {
    //     if (!_.trim(bornDate || '')) {
    //         Alert.warning('Por favor, ingrese una fecha de nacimiento válida.', 5000);
    //         return false;
    //     }
    //     if (getAge(bornDate) < 18) {
    //         Alert.warning('Por favor, ingrese una fecha de nacimiento válida.', 5000);
    //         return false;
    //     }
    //     return true;
    // };

    //
    // Main component
    //

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`${show ? 'show in' : ''} modal-responsive`}
            aria-labelledby='seller-create-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id='seller-create-modal'>
                    {!isLoading && (<span>Crear Usuario</span>)}
                    {isLoading && <span>Creando Usuario...</span>}
                </Modal.Title>
            </Modal.Header>
            <FormikWrapper
                initialValues={sellerRegistrationInitialState}
                validationSchema={sellerRegistrationValidationSchema}
                id='sellerRegistrationForm'
                handleSubmit={handleSubmit}
            >
                <Modal.Body className='py-1'>
                    {!isLoading && (
                        <div className='row justify-content-center m-0'>
                            <div className='col-lg-8'>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'fit-content', margin: 'auto' }}>
                                    <InputElement name={name.name} label={name.label + '*'}/>
                                    <InputElement name={lastName.name} label={lastName.label + '*'}/>
                                    <InputElement name={dni.name} label={dni.label} showCustomError={showError.dni} customError={'Por favor ingrese otro documento'}/>
                                    <InputElement name={user.name} label={user.label + '*'} showCustomError={showError.user} customError={'Por favor ingrese otro usuario'}/>
                                    <InputElement name={password.name} label={password.label + '*'}/>
                                    <InputElement name={businessId.name} label={businessId.label + '*'}/>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                                        <FormGroup style={{ margin: 0 }}>
                                            <ControlLabel>Fecha de nacimiento</ControlLabel>
                                            <DatePicker
                                                className='mr-3'
                                                block
                                                oneTap
                                                style={{ width: 150 }}
                                                size='md'
                                                placeholder='Fecha nacimiento'
                                                renderValue={(value, format) => `${dateFns.format(value, 'dd/MM/y')}`}
                                                onChange={setBornDate}
                                                onClean={() => setBornDate(null)}
                                            />
                                        </FormGroup>
                                        <RadioButtonGroup type="radio" name={gender.name} values={genderValues} legend='Género'/>
                                    </Box>
                                    <RadioButtonGroup type="radio" name={role.name} values={rolesValues} legend='Rol*'/>
                                </Box>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className='mt-4'>
                    <div>
                        <Button appearance='primary' disabled={isLoading} type='submit'>Aceptar</Button>
                        <Button appearance='subtle' disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    </div>
                </Modal.Footer>
            </FormikWrapper>

        </Modal>
    );
};
